import TopNav from "@/pages/home/components/TopNav";
import HeroSection from "@/pages/home/components/HeroSection";
import CollectionsSection from "@/pages/home/components/CollectionsSection";
import HotVideosSection from "@/pages/home/components/HotVideosSection";
import WelfareSection from "@/pages/home/components/WelfareSection";
import LatestResourcesSection from "@/pages/home/components/LatestResourcesSection";
import TrustFaqSection from "@/pages/home/components/TrustFaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopNav />
      <main className="w-full">
        <HeroSection />
        <CollectionsSection />
        <HotVideosSection />
        <WelfareSection />
        <LatestResourcesSection />
        <TrustFaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}